/* Guide navigation and referral measurement. Links always work, including without analytics consent. */
(() => {
  if (window.joyoReferralsBound) return;
  window.joyoReferralsBound = true;
  const measurementId = 'G-EKRSZD14WB';
  function track(event) {
    if (event.type === 'auxclick' && event.button !== 1) return;
    const link = event.target.closest?.('a[href]');
    if (!link || event.defaultPrevented) return;
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return;
    let destination;
    try { destination = new URL(link.href); } catch { return; }
    if (destination.protocol !== 'https:') return;
    const guideAudiences = {
      '/pages/womens-barefoot-shoes': 'women',
      '/pages/best-kids-barefoot-shoes': 'kids'
    };
    const destinationPath = destination.pathname.replace(/\/$/, '');
    const guideAudience = destination.hostname === location.hostname && guideAudiences[destinationPath];
    const samePage = destinationPath === location.pathname.replace(/\/$/, '');
    const internal = destination.hostname === location.hostname || destination.hostname.endsWith('.joyobarefoot.com') || destination.hostname === 'joyobarefoot.com';
    if (internal && (!guideAudience || samePage)) return;
    if (!internal && !link.hasAttribute('data-joyo-referral')) return;
    // Use the already installed GA4 destination; do not create a second page-view tag.
    window.dataLayer = window.dataLayer || [];
    const gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    if (guideAudience) {
      let placement = 'site_link';
      if (link.closest('[data-journal-body]')) placement = 'article_body';
      else if (link.closest('.journal-article__rail')) placement = 'article_sidebar';
      else if (link.closest('.journal-article__continue')) placement = 'article_end';
      gtag('event', 'guide_open', {
        send_to: measurementId,
        audience: guideAudience,
        placement,
        transport_type: 'beacon'
      });
      return;
    }
    gtag('event', 'referral_outbound', {
      send_to: measurementId,
      retailer: (link.dataset.retailer || destination.hostname).slice(0, 100),
      audience: link.dataset.audience || 'general',
      item_name: (link.dataset.item || '').slice(0, 100),
      placement: link.dataset.placement || 'guide',
      destination_host: destination.hostname,
      transport_type: 'beacon'
    });
  }
  document.addEventListener('click', track);
  document.addEventListener('auxclick', track);
  // Shopify's privacy API can be loaded independently of the cookie-banner UI.
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }
})();
